import React from 'react';

function VisaIcon() {
  return (
    <svg
      width="63"
      height="29"
      viewBox="0 0 63 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.7251 24.5455H21.6947L24.8386 5.22415H29.8695L26.7251 24.5455ZM17.4629 5.22415L12.6671 18.5136L12.0996 15.6518L12.1002 15.6529L10.4075 6.96382C10.4075 6.96382 10.2029 5.22415 8.02129 5.22415H0.0930306L0 5.55131C0 5.55131 2.42448 6.05574 5.26191 7.75975L9.63227 24.5461H14.8735L22.8767 5.22415H17.4629ZM57.0292 24.5455H61.6482L57.621 5.22364H53.5773C51.7099 5.22364 51.2551 6.66354 51.2551 6.66354L43.7527 24.5455H48.9966L50.0452 21.6756H56.44L57.0292 24.5455ZM51.4939 17.7109L54.137 10.4804L55.6239 17.7109H51.4939ZM44.1461 9.87051L44.8639 5.72135C44.8639 5.72135 42.6488 4.87891 40.3396 4.87891C37.8432 4.87891 31.9151 5.96995 31.9151 11.2753C31.9151 16.2669 38.8728 16.3289 38.8728 18.9508C38.8728 21.5727 32.632 21.1029 30.5724 19.4495L29.8245 23.7879C29.8245 23.7879 32.0707 24.8789 35.5025 24.8789C38.9353 24.8789 44.114 23.1015 44.114 18.2639C44.114 13.2403 37.0938 12.7725 37.0938 10.5884C37.0943 8.40373 41.9934 8.68437 44.1461 9.87051Z"
        fill="#2566AF"
      />
      <path
        d="M12.1002 15.6522L10.4075 6.96318C10.4075 6.96318 10.2029 5.22351 8.02129 5.22351H0.0930306L0 5.55067C0 5.55067 3.81063 6.34039 7.46569 9.29928C10.9605 12.1274 12.1002 15.6522 12.1002 15.6522Z"
        fill="#E6A540"
      />
    </svg>
  );
}

export default VisaIcon;
